import scenes from './constants'

const getStatus = ({ pathname }: { pathname: string }) => {
  if (pathname.includes(scenes.LOBBY)) {
    return 'empty'
  }
  return 'goToStore'
}

export default getStatus
